import React from "react";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { imageList } from "@/core/utils/imageList";

interface RequestsSectionProps {
  requests: Record<string, any>;
  loading: boolean;
  processingRequest: string | null;
  onAccept: (actionId: string) => void;
  onDeny: (actionId: string) => void;
}

export const RequestsSection: React.FC<RequestsSectionProps> = ({
  requests,
  loading,
  processingRequest,
  onAccept,
  onDeny,
}) => {
  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  if (!requests || Object.keys(requests).length === 0) {
    return null;
  }

  return (
    <div className="tab-row requests-to-join">
      <div className="tab-row-texts">
        <label>Requests to join</label>
        Accept or decline user requests to join your idea
      </div>
      <div className="invitation-list">
        <div className="invitations-content">
          <div className="requests-section">
            <div className="space-y-3">
              {Object.entries(requests).map(
                ([partnerId, requestData]: [string, any]) => {
                  const userActionsArray = Object.entries(
                    requestData.user_actions
                  ).map(([actionId, userData]: [string, any]) => ({
                    actionId,
                    ...userData,
                  }));

                  return userActionsArray.map((userAction) => (
                    <div
                      key={`request-${userAction.actionId}`}
                      className="invitation-item-grid"
                    >
                      <div className="invitation-avatar">
                        <img
                          src={
                            userAction.user_data?.logo_uri || imageList.noimage
                          }
                          alt={userAction.user_data?.firstname || "User"}
                          className="invitation-avatar-img"
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.src = imageList.noimage;
                          }}
                        />
                      </div>

                      <div className="invitation-info">
                        <div className="invitation-title">
                          {userAction.user_data?.firstname &&
                          userAction.user_data?.lastname
                            ? `${userAction.user_data.firstname} ${userAction.user_data.lastname}`
                            : userAction.user_data?.email || "Unknown User"}
                        </div>
                        <div className="invitation-subtitle">
                          Request to join •{" "}
                          {userAction.user_data?.job_title || "User request"}
                        </div>
                        <div className="partner-info">
                          Partner:{" "}
                          {requestData.partner?.title || "Unknown Partner"}
                        </div>
                      </div>

                      <div className="invitation-actions">
                        <button
                          className="accept-btn"
                          onClick={() => onAccept(userAction.action_id)}
                          disabled={processingRequest === userAction.actionId}
                        >
                          <SvgIcon icon="icon-accept" />
                          {processingRequest === userAction.action_id
                            ? "Accepting..."
                            : "Accept request to join"}
                        </button>
                        <button
                          className="deny-btn"
                          onClick={() => onDeny(userAction.action_id)}
                          disabled={processingRequest === userAction.actionId}
                        >
                          <SvgIcon icon="icon-withdraw" />
                          {processingRequest === userAction.actionId
                            ? "Denying..."
                            : "Deny"}
                        </button>
                      </div>
                    </div>
                  ));
                }
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
